"use client";

import { useEffect } from "react";

export function DatadogInit() {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const appId = process.env.NEXT_PUBLIC_DD_APPLICATION_ID;
    const clientToken = process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN;

    if (!appId || !clientToken) {
      if (process.env.NODE_ENV === "development") {
        console.debug("[Datadog] Skipping init - missing env vars", {
          hasAppId: !!appId,
          hasClientToken: !!clientToken,
        });
      }
      return;
    }

    async function initDatadog() {
      const { datadogRum } = await import("@datadog/browser-rum");
      const { datadogLogs } = await import("@datadog/browser-logs");

      if (datadogRum.getInitConfiguration()) return;

      datadogRum.init({
        applicationId: appId!,
        clientToken: clientToken!,
        site: "us5.datadoghq.com",
        service: "mercata-web-app",
        env: process.env.NEXT_PUBLIC_VERCEL_ENV || process.env.NODE_ENV,
        version: process.env.NEXT_PUBLIC_APP_VERSION,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        trackBfcacheViews: true,
        defaultPrivacyLevel: "mask-user-input",
      });

      datadogLogs.init({
        clientToken: clientToken!,
        site: "us5.datadoghq.com",
        service: "mercata-web-app",
        env: process.env.NEXT_PUBLIC_VERCEL_ENV || process.env.NODE_ENV,
        forwardErrorsToLogs: true,
        sessionSampleRate: 100,
      });

      if (process.env.NODE_ENV === "development") {
        console.debug("[Datadog] RUM and Logs initialized", {
          env: process.env.NEXT_PUBLIC_VERCEL_ENV || process.env.NODE_ENV,
        });
      }
    }

    initDatadog();
  }, []);

  return null;
}